export default __webpack_public_path__ + "static/media/icon-chevron-stop-right.3e195fd3.svg";